export default "//static.tradera.net/touchweb/static/output/images/category-childrens-clothing-shoes.c2f83146.svg";